import { render } from "./PreMadeList.vue?vue&type=template&id=309d0aec"
import script from "./PreMadeList.vue?vue&type=script&lang=js"
export * from "./PreMadeList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__